<template>
  <v-card flat class="rounded-xl overflow-hidden pa-8">
    
    <!-- هدر و دکمه‌های اکشن -->
    <div class="d-flex flex-column flex-lg-row align-center justify-space-between mb-6 gap-4">
      <v-spacer class="d-none d-lg-block"></v-spacer>

      <div class="d-flex flex-wrap justify-center justify-lg-end gap-3">
        <v-btn class="btn-get-code rounded-lg" @click="openAddModal">
          <v-icon left>mdi-plus</v-icon>
          ایجاد استراتژی جدید
        </v-btn>
      </div>
    </div>
    
    <vue-table
      :data="tableData"
      :headers="headers"
      :loading="loading"
      @change="onPagination"
      item-key="id"
    >
      <template v-slot:index="{ item, index }">
        {{ persian(item.index + 1 + ((tableProps.page || 1) - 1) * (tableProps.length || 10)) }}
      </template>

      <template v-slot:strategy="{ item }">
        <v-chip :color="item.strategy === 'buybox' ? 'info': item.strategy === 'margin_plus'? 'warning' : 'success'" small class="font-weight-bold px-3 rounded-lg" text-color="white">
          <v-icon right small class="mr-n1 ml-1">
            {{ item.strategy === 'buybox' ? 'mdi-package-check': item.strategy === 'margin_plus'?'mdi-trending-up' : 'mdi-cash' }}
          </v-icon>
          {{ item.strategy === 'buybox' ? 'بای باکس' : item.strategy === 'margin_plus'? 'سود ثابت':item.strategy }}
        </v-chip>
      </template>
      
      <template v-slot:marketplace="{ item }">
        <v-chip
          small
          label
          :color="getMarketplaceBadge(item.marketplace).color"
          :text-color="getMarketplaceBadge(item.marketplace).textColor"
          class="font-weight-bold"
        >
          <v-icon left x-small>{{ getMarketplaceBadge(item.marketplace).icon }}</v-icon>
          {{ getMarketplaceBadge(item.marketplace).title }}
        </v-chip>
      </template>

      <template v-slot:updated_at="{ item }">
        <span class="font-weight-bold primary--text">
            {{ jalalian(item.updated_at) }}
        </span>
      </template>
      
      <template v-slot:rules="{ item }">
        <div v-if="item.rules && Object.keys(item.rules).length > 0" class="d-flex flex-wrap gap-1">
          <v-chip
            v-for="(value, key) in item.rules"
            :key="key"
            small
            outlined
            color="primary"
            class="font-weight-medium"
            dir="ltr"
          >
            <strong class="mx-1">{{ persian(value) }}</strong>
            <span class="grey--text text--darken-1 mr-1">:{{ persian(translateKey(key).label) }}</span>
            <v-icon small >{{translateKey(key).icon}}</v-icon>
          </v-chip>
        </div>
        <span v-else class="grey--text text-caption"> بی قانون</span>
      </template>

      <template v-slot:is_active="{ item }">
        <v-icon :color="item.is_active ? 'success' : 'error'">
          {{ item.is_active ? 'mdi-check-circle' : 'mdi-close-circle' }}
        </v-icon>
      </template>

      <template v-slot:action="{ item }">
        <action-buttons :data="item" :meta="metabutton(item)" />
      </template>
    </vue-table>

    <!-- مودال افزودن / ویرایش -->
    <custom-popup
      v-model="showDialog"
      :cons="{ title: isEditing ? 'ویرایش استراتژی' : 'ایجاد استراتژی جدید' ,icon:'strategy'}"
      max-width="800"
      :reloadable="false"
      :persistent="true"
      @close="closeModal"
    >
      <v-card class="pa-2" flat>
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="pa-5 border rounded-xl" style="background: #f9f9f9">
            
            <v-row class="mb-2">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.name"
                  label="عنوان استراتژی"
                  prepend-inner-icon="mdi-format-title"
                  outlined
                  dense
                  class="bg-white"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="formData.marketplace"
                  :items="marketplacesList"
                  label="مارکت پلیس"
                  prepend-inner-icon="mdi-storefront"
                  outlined
                  dense
                  class="bg-white"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
            </v-row>

            <v-row class="mb-4">
              <v-col cols="12">
                <div class="d-flex flex-column flex-sm-row align-start align-sm-center justify-start">
                  <span class="ml-sm-4 mb-3 mb-sm-0 font-weight-bold grey--text text--darken-1 text-body-2">
                    دسته‌بندی استراتژی:
                  </span>
                  
                  <v-btn-toggle
                    v-model="formData.strategy"
                    mandatory
                    rounded
                    class="d-flex w-100 flex-sm-row"
                    color="primary"
                    background-color="grey lighten-4"
                  >
                    <v-btn value="buybox" active-class="primary white--text elevation-3" class="flex-grow-1">
                      <v-icon right size="22" :class="formData.strategy === 'buybox' ? 'white--text' : 'grey--text'">mdi-package-check</v-icon>
                      <span class="mr-2 font-weight-bold" :class="formData.strategy === 'buybox' ? 'white--text' : 'grey--text text--darken-2'">بای باکس</span>
                    </v-btn>

                    <v-btn value="margin_plus" active-class="primary white--text elevation-3" class="flex-grow-1">
                      <v-icon right size="22" :class="formData.strategy === 'margin_plus' ? 'white--text' : 'grey--text'">mdi-trending-up</v-icon>
                      <span class="mr-2 font-weight-bold" :class="formData.strategy === 'margin_plus' ? 'white--text' : 'grey--text text--darken-2'">سود ثابت</span>
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </v-col>
            </v-row>

            <!-- بخش قوانین داینامیک و نامحدود -->
            <v-card outlined class="pa-4 rounded-lg bg-white border mb-4">
              <div class="d-flex justify-space-between align-center mb-4">
                <div class="subtitle-2 font-weight-bold primary--text">قوانین محاسباتی استراتژی</div>
                <v-btn class="btn-get-code rounded-lg" @click="addRule">
                  <v-icon left>mdi-plus</v-icon>افزودن قانون 
                </v-btn>
              </div>

              <!-- حلقه برای نمایش قوانین -->
              <v-row v-for="(rule, index) in formData.rules" :key="index" class="align-center mb-2">
                <v-col cols="12" md="5" class="py-1">
                  <v-text-field
                    v-model="rule.key"
                    label="کلید (مثال: price_step)"
                    outlined
                    dense
                    hide-details
                    dir="ltr"
                    placeholder="Key..."
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5" class="py-1">
                  <v-text-field
                    v-model="rule.value"
                    label="مقدار (مثال: 20000)"
                    outlined
                    dense
                    hide-details
                    dir="ltr"
                    placeholder="Value..."
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="py-1 text-center">
                  <v-btn icon small class="btn-delete rounded-pill" @click="removeRule(index)" title="حذف این قانون">
                    <v-icon >mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <div v-if="formData.rules.length === 0" class="text-center grey--text text-caption py-3">
                هیچ قانونی تعریف نشده است. برای افزودن روی دکمه "افزودن قانون" کلیک کنید.
              </div>
            </v-card>

            <v-row>
              <v-col cols="12" class="pt-0">
                <v-switch 
                  v-model="formData.is_active" 
                  label="استراتژی فعال باشد" 
                  inset 
                  dense
                  hide-details
                  color="success"
                ></v-switch>
              </v-col>
            </v-row>

            <div class="d-flex flex-row justify-end gap-3 mt-6">
              <v-btn class="btn-delete rounded-lg px-6" @click="closeModal" :disabled="saveLoading">
                <v-icon left>mdi-close</v-icon> انصراف
              </v-btn>    
              <v-spacer/>    
              <v-btn 
                :loading="saveLoading" 
                class="btn-get-code rounded-lg px-8" 
                @click="saveStrategy" 
                :disabled="!valid"
              >
                <v-icon left>mdi-check</v-icon> {{ isEditing ? 'ثبت تغییرات' : 'ذخیره استراتژی' }}
              </v-btn>  
            </div>
            
          </div>
        </v-form>
      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";

export default {
  name: "SmartPricingStrategies",
  components: {
    ActionButtons
  },
  data() {
    return {
      marketplacesList: [
        { text: 'دیجی‌کالا', value: 'digikala' },
        { text: 'باسلام', value: 'basalam' },
        { text: 'اسنپ‌شاپ', value: 'snappshop' }
      ],
      loading: false,
      saveLoading: false,
      actionLoading: null,
      showDialog: false,
      isEditing: false,
      valid: false,
      tableProps: {
        page: 1,
        length: 10,
      },
      tableData: {
        data: [],
        total: 0,
        current_page: 1,
        per_page: 10
      },
      
      headers: [
        { text: "ردیف", value: "index", sortable: false, align: "center" },
        { text: "عنوان استراتژی", value: "name", align: "start" },
        { text: "استراتژی", value: "strategy", align: "center" },
        { text: "مارکت پلیس", value: "marketplace", align: "center" },
        { text: "وضعیت", value: "is_active", align: "center" },
        { text: 'قوانین', value:'rules', align: 'center' },
        { text:'آخرین به روزرسانی',value:'updated_at',align:"center"},
        { text: "عملیات", value: "action", sortable: false, align: "center" },
      ],

      formData: this.getInitialFormData(),
      
      rules: {
        required: v => (v !== null && v !== '' && v !== undefined) || 'این فیلد الزامی است.',
      }
    };
  },

  mounted() {
    this.fetchStrategies();
  },

  methods: {
translateKey(value) {
  const pricingStrategyFields = [
    { 
      key: 'price_step', 
      label: 'گام قیمت', 
      hint: 'میزان کاهش یا افزایش نسبت به رقیب', 
      icon: 'mdi-stairs' // نشان‌دهنده پله / گام تغییرات
    },
    { 
      key: 'round_to', 
      label: 'رُند کردن به', 
      hint: 'مثلاً رند به مضرب ۱,۰۰۰ یا ۵,۰۰۰', 
      icon: 'mdi-approximately-equal' // علامت تقریب / رُند کردن
    },
    { 
      key: 'profit_percent', 
      label: 'حداقل درصد سود', 
      hint: 'برای جلوگیری از ضرر در رقابت', 
      icon: 'mdi-percent' // درصد و سود
    },
    { 
      key: 'min_price', 
      label: 'کف قیمت (حداقل قیمت فروش)', 
      hint: 'پایین‌ترین حد مجاز قیمت',
      icon: 'mdi-format-vertical-align-bottom' // تراز به کف / حداقل
    },
    { 
      key: 'max_price', 
      label: 'سقف قیمت (حداکثر قیمت فروش)', 
      hint: 'بالاترین حد مجاز قیمت',
      icon: 'mdi-format-vertical-align-top' // تراز به سقف / حداکثر
    },
  ];
  return pricingStrategyFields.find(x => x.key === value) || { key: value, label: value, icon: 'mdi-help-circle-outline' };
},
    isNumber(val) {
    if (val === null || val === undefined || val === '') return false;
    return !isNaN(Number(val));
  },
    getMarketplaceBadge(marketplace) {
      const map = {
        digikala: { title: "دیجی‌کالا", color: "red lighten-5", textColor: "red darken-2", icon: "mdi-shopping" },
        basalam: { title: "باسلام", color: "orange lighten-5", textColor: "orange darken-3", icon: "mdi-storefront" },
        snappshop: { title: "اسنپ‌شاپ", color: "green lighten-5", textColor: "green darken-2", icon: "mdi-truck-fast" },
      };
      return map[marketplace] || { title: marketplace || "نامشخص", color: "grey lighten-3", textColor: "grey darken-2", icon: "mdi-web" };
    },

    metabutton(item) {
      const buttons = [
        {
          name: "edit",
          label: "ویرایش",
          icon: "pencil-outline",
          class: "btn-get-code rounded-pill",
          action: (row) => this.openEditModal(row),
        },
        {
          name: "delete",
          label: "حذف",
          icon: "trash-can-outline",
          class: "btn-delete rounded-pill",
          action: (row) => this.deleteStrategy(row),
        }
      ];
      return { buttons };
    },

    getInitialFormData() {
      return {
        id: null,
        name: "",
        strategy: "buybox",
        marketplace: '',
        // به جای یک آبجکت ثابت، اینجا را یک آرایه در نظر می‌گیریم تا قابلیت Loop داشته باشد
        rules: [{ key: '', value: '' }], 
        is_active: true,
      };
    },

    addRule() {
      this.formData.rules.push({ key: '', value: '' });
    },

    removeRule(index) {
      this.formData.rules.splice(index, 1);
    },

    onPagination(props) {
      if(props) {
        this.tableProps = { ...this.tableProps, ...props };
      }
      this.fetchStrategies();
    },

    async fetchStrategies() {
      this.loading = true;
      try {
        const res = await this.$api.get('/v1/smart-pricing-strategies', {
          params: this.tableProps
        });
        this.tableData = res.data.data || res.data;
      } catch (error) {
        this.$toast.error("خطا در دریافت لیست استراتژی‌ها");
      } finally {
        this.loading = false;
      }
    },

    openAddModal() {
      this.isEditing = false;
      this.formData = this.getInitialFormData();
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.showDialog = true;
    },

    async openEditModal(item) {
      this.actionLoading = item.id;
      try {
        const res = await this.$api.get(`v1/smart-pricing-strategies/${item.id}`);
        const data = res.data.data || res.data;
        
        // تبدیل آبجکت دریافتی از سرور به آرایه کلید و مقدار برای نمایش در فرم
        let parsedRules = [];
        if (data.rules && typeof data.rules === 'object') {
          parsedRules = Object.entries(data.rules).map(([k, v]) => ({ key: k, value: v }));
        }
        
        // اگر سرور آبجکت خالی برگرداند، حداقل یک سطر خالی برای کاربر ایجاد می‌کنیم
        if (parsedRules.length === 0) {
          parsedRules.push({ key: '', value: '' });
        }
        
        this.formData = {
          id: data.id,
          name: data.name,
          strategy: data.strategy,
          marketplace: data.marketplace,
          rules: parsedRules,
          is_active: data.is_active,
        };
        
        this.isEditing = true;
        this.showDialog = true;
      } catch (error) {
        this.$toast.error("خطا در دریافت اطلاعات استراتژی");
      } finally {
        this.actionLoading = null;
      }
    },

    closeModal() {
      this.showDialog = false;
      setTimeout(() => {
        this.formData = this.getInitialFormData();
        if (this.$refs.form) this.$refs.form.resetValidation();
      }, 300);
    },

    async saveStrategy() {
      if (!this.$refs.form.validate()) {
        this.$toast.error("لطفاً خطاهای فرم را برطرف کنید.");
        return;
      }

      this.saveLoading = true;
      try {
        // ساختن آبجکت نهایی برای ارسال به بک‌اند
        const finalRulesObj = {};
        
        this.formData.rules.forEach(rule => {
          // اگر فیلد کلید خالی نبود، آن را به عنوان پراپرتی جدید اضافه کن
          if (rule.key && rule.key.trim() !== '') {
            let val = rule.value;
            // تلاش برای تبدیل به عدد (چون معمولا قیمت یا درصد هستند)
            // اگر کاربر به جای عدد حرف تایپ کرده بود، همان رشته متنی ذخیره می‌شود
            let cleanedVal = String(val).replace(/,/g, ''); // حذف کاماها اگر عدد پولی وارد کرده بود
            
            if (!isNaN(Number(cleanedVal)) && cleanedVal !== '') {
              finalRulesObj[rule.key.trim()] = Number(cleanedVal);
            } else {
              finalRulesObj[rule.key.trim()] = val;
            }
          }
        });

        const payload = {
          name: this.formData.name,
          strategy: this.formData.strategy,
          marketplace: this.formData.marketplace,
          rules: finalRulesObj,
          is_active: this.formData.is_active,
        };

        if (this.isEditing) {
          await this.$api.put(`/v1/smart-pricing-strategies/${this.formData.id}`, payload);
          this.$toast.success("استراتژی با موفقیت ویرایش شد.");
        } else {
          await this.$api.post('/v1/smart-pricing-strategies', payload);
          this.$toast.success("استراتژی جدید با موفقیت ایجاد شد.");
        }

        this.closeModal();
        this.fetchStrategies();
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "خطا در ذخیره اطلاعات");
      } finally {
        this.saveLoading = false;
      }
    },

    deleteStrategy(item) {
      this.$modal.yesNo(`آیا از حذف استراتژی «${item.name}» اطمینان دارید؟`).then(async () => {
        this.loading = true;
        try {
          await this.$api.delete(`/v1/smart-pricing-strategies/${item.id}`);
          this.$toast.success("استراتژی با موفقیت حذف شد.");
          
          if (this.tableData?.data?.length === 1 && this.tableProps?.page > 1) {
            this.tableProps.page--;
          }
          this.fetchStrategies();
        } catch (error) {
          this.$toast.error(error.response?.data?.message || "خطا در حذف استراتژی");
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.gap-2 { gap: 8px; }
.gap-3 { gap: 12px; }
.gap-4 { gap: 16px; }
.bg-white { background-color: white !important; }
.border { border: 1px solid #e0e0e0 !important; }
</style>
